/* --- Styles --- */
import "./css-shell/main.css";
import "./page-styles/webfonts.css";
import "./page-styles/header.css";
import "./page-styles/base.css";
import "./page-styles/navigation.css";
import "./page-styles/article.css";
import "./page-styles/breadcrumbs.css";
import "./page-styles/person.css";
import "./page-styles/footer.css";

/* --- Application --- */
import Vue from "vue";
import Vuex from "vuex";
import LazyMediaDom from "./components/lazy-media-dom";
import LazyLogo from "./components/lazy-logo";
import { Carousel } from "./components/carousel";
import LightboxController from "./components/media/lightbox-controller.vue";
import LightboxCarousel from "./components/media/lightbox-carousel.vue";
import MediaCarousel from "./components/media/media-carousel.vue";
import LazyMedia from "./components/media/lazy-media.vue";
import Swipe from "./components/swipe.vue";
import CookieBanner from "./components/cookie-banner.vue";
import store from "./store";

Vue.use(Vuex);

Vue.component("lazy-media-dom", LazyMediaDom);
Vue.component("lazy-logo", LazyLogo);
Vue.component("multi-carousel", Carousel);

Vue.component("lightbox-controller", LightboxController);
Vue.component("lightbox-carousel", LightboxCarousel);
Vue.component("media-carousel", MediaCarousel);
Vue.component("lazy-media", LazyMedia);
Vue.component("v-swipe", Swipe);
Vue.component("cookie-banner", CookieBanner);

const vm = new Vue({
    store,
    data: {
        isMenuOpen: false,
    },
    methods: {
        openMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
    },
});

vm.$mount("#view");

const menuToggle = document.querySelector('.menu-toggle') as HTMLElement | null;
const menu = document.querySelector('.menu-container') as HTMLElement | null;

if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
        menu.classList.toggle('active');
        menuToggle.classList.toggle('active');
        document.body.classList.toggle('no-scroll'); // Scrollen verhindern

        // Reset opacity for all menu items
        document.querySelectorAll('.menu li .parent-link').forEach(link => {
            link.classList.remove('hovered');
            link.style.opacity = "1";
        });

        // Close all submenus when menu is closed
        if (!menu.classList.contains('active')) {
            document.querySelectorAll('.menu li .submenu').forEach(submenu => {
                submenu.classList.remove('submenu-visible');
            });

            // Ensure all parent links are not marked as hovered
            document.querySelectorAll('.menu li .parent-link').forEach(link => {
                link.classList.remove('hovered');
            });
        }
    });
}
// Handle hover behavior for submenu items
document.querySelectorAll('.menu li .parent-link').forEach(item => {
    item.addEventListener('mouseenter', () => {
        if (window.innerWidth > 1024) {
            document.querySelectorAll('.menu li .parent-link').forEach(link => {
                link.classList.remove('hovered');
                link.style.opacity = "0.5";
            });
            document.querySelectorAll('.menu li .submenu').forEach(submenu => {
                submenu.classList.remove('submenu-visible');
            });

            item.classList.add('hovered');
            item.style.opacity = "1";

            const submenu = item.nextElementSibling as HTMLElement | null;
            if (submenu && submenu.classList.contains('submenu')) {
                submenu.classList.add('submenu-visible');
            }
        }
    });
});

const arrows = document.querySelectorAll('.parent-link .arrow');

arrows.forEach(arrow => {
    arrow.addEventListener('click', (event) => {
        event.stopPropagation();
        const parentLink = arrow.closest('.parent-link');
        const submenu = parentLink.nextElementSibling;

        // Close all other submenus
        document.querySelectorAll('.menu li .submenu').forEach(otherSubmenu => {
            if (otherSubmenu !== submenu) {
                otherSubmenu.classList.remove('submenu-visible');
            }
        });

        if (submenu && submenu.classList.contains('submenu')) {
            submenu.classList.toggle('submenu-visible');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const isHomepage = document.body.classList.contains('-home');
    const shouldSkipAnimation = localStorage.getItem('shouldSkipAnimation') === 'true';

    if (isHomepage && !shouldSkipAnimation) {
        playIntroAnimationAfterDelayOrScroll();
    } else {
        skipIntroAnimation();
    }

    if (!isHomepage) {
        localStorage.setItem('shouldSkipAnimation', 'true');
    } else{
        localStorage.setItem('shouldSkipAnimation', 'false');
    }

});

window.addEventListener('beforeunload', () => {
    const isHomepage = document.body.classList.contains('-home');
    if (!isHomepage) {
        localStorage.setItem('shouldSkipAnimation', 'true');
    }
});
function playIntroAnimationAfterDelayOrScroll() {
    const header = document.querySelector('header');
    const hiddenElements = document.querySelectorAll('.hidden-until-explore');
    const logoVideo = document.querySelector('.logoVideo');
    const searchInput = document.querySelector('.search-input');
    const menuToggle = document.querySelector('.menu-toggle');


    header.classList.remove('normal-header');
    header.classList.add('fullscreen-header');

    if (header.classList.contains('fullscreen-header')) {
        logoVideo.classList.add('intro-position');
        logoVideo.classList.remove('normal-position');
    }

    const playAnimation = () => {
        header.classList.remove('fullscreen-header');
        header.classList.add('normal-header');

        logoVideo.classList.remove('intro-position');
        logoVideo.classList.add('normal-position');

        hiddenElements.forEach(element => {
            element.classList.remove('hidden-until-explore');
        });

        if (searchInput) {
            searchInput.classList.add('visible');
        }
        if (menuToggle) {
            menuToggle.classList.add('visible');
        }
    };

    setTimeout(playAnimation, 5000);

    const handleScroll = () => {
        if (header.classList.contains('fullscreen-header')) {
            playAnimation();
            window.removeEventListener('scroll', handleScroll);
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
}

function skipIntroAnimation() {
    const header = document.querySelector('header');
    const hiddenElements = document.querySelectorAll('.hidden-until-explore');
    const searchInput = document.querySelector('.search-input');
    const menuToggle = document.querySelector('.menu-toggle');
    const logoVideo = document.querySelector('.logoVideo');

    header.classList.remove('fullscreen-header');
    header.classList.add('normal-header');

    hiddenElements.forEach(element => {
        element.classList.remove('hidden-until-explore');
    });

    document.body.classList.remove('no-scroll');

    if (searchInput) {
        searchInput.classList.add('visible');
    }
    if (menuToggle) {
        menuToggle.classList.add('visible');
    }

    logoVideo.classList.add('normal-position');
    logoVideo.classList.remove('intro-position');
}

document.querySelectorAll('.menu li .submenu li').forEach(submenuItem => {
    submenuItem.addEventListener('mouseenter', () => {
        submenuItem.style.opacity = "1";
        submenuItem.parentElement.querySelectorAll('li').forEach(sibling => {
            if (sibling !== submenuItem) {
                sibling.style.opacity = "0.5";
            }
        });
    });

    submenuItem.addEventListener('mouseleave', () => {
        submenuItem.style.opacity = "1";
    });
});

document.querySelectorAll('.menu li .submenu').forEach(submenu => {
    submenu.addEventListener('mouseleave', () => {
        submenu.querySelectorAll('li').forEach(item => {
            item.style.opacity = "1";
        });
    });
});

